<template>
  <div>
    <Spinner v-if="loading"/>

    <div class='unowned-books' v-else>
      <BooksSlider
          title="Complete your collection"
          :books="books"
          v-if="books && books.length > 0"
      ></BooksSlider>

      <div class="cta-card" v-else style="margin-bottom: 40px;">
        <h3>Je bent geweldig.</h3>
        <p>Normaal gesproken toon ik hier de boeken die je nog niet in je bezit hebt, maar jij hebt alle e-books al!
          Enorm bedankt en geniet ervan.</p>
        <router-link
            class="btn"
            :to="{name: 'pages.books'}"
        >
          Naar jouw boekenplank
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import BooksSlider from "./BooksSlider.vue";
import Spinner from "../../blocks/Spinner.vue";

export default {
  name: "UnownedBooks",
  data() {
    return {
      books: [], // Filtered books array
      loading: true,
    };
  },
  props: {
    exclude: {
      type: Array, // Expect an array of book IDs to exclude
      default: () => [], // Default to an empty array
    },
  },
  components: {
    BooksSlider,
    Spinner
  },
  watch: {
    // Re-initialize if the route changes
    $route() {
      this.init();
    },
    // Re-apply filtering when `exclude` changes
    exclude: {
      immediate: true,
      handler(newVal) {
        if (newVal && this.books.length > 0) {
          this.filterBooks(newVal);
        }
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions("book", ["getUnownedBooks"]),

    async init() {
      try {
        const response = await this.getUnownedBooks();
        this.books = response; // Set all books initially
        this.loading = false;
        if (this.exclude && this.exclude.length > 0) {
          this.filterBooks(this.exclude); // Apply filtering
        }
      } catch (error) {
        console.error("Error fetching unowned books:", error);
      }
    },

    filterBooks(excludeIds) {
      this.books = this.books.filter((book) => !excludeIds.includes(book.id));
    },
  },
};
</script>
